export default {"src":"/_next/static/media/icon-calendar-career.4741d6a5.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};